import { defaultClientOptions } from '../common/index.js';
export const ApigeeDomains = {
    DOMAIN_DEV: 'https://api.dev.awstrp.net',
    DOMAIN_STAGE: 'https://api.stage.awstrp.net',
    DOMAIN_PROD: 'https://api.public.troweprice.com',
};
export const BaseApiConstants = {
    ...ApigeeDomains,
    CLIENT_DEFAULT_OPTS: defaultClientOptions,
    LOG_REQUIRED_BOTH: 'endpoint and apikey required',
    LOG_REQUIRED_ENDPOINT: 'endpoint required',
    LOG_REQUIRED_APIKEY: 'apikey required',
    LOG_WARN_TYPEDEFS: 'No typedefs configured in clientOptions',
};
//# sourceMappingURL=base-api.constants.js.map